import { http } from "../api/http";

// RamBot (#2448) — cross-client "which clients use which systems/objects" chat. Same host/auth
// shape as aiBuilder/kbBuilder services, but stateless: no server-owned conversationId, the
// caller resends whatever transcript it wants considered as priorMessages.
export const ramBotService = {
  ask,
};

async function ask(payload) {
  const response = await http.post("/ai-builder/ask", JSON.stringify(payload));
  return response.data;
}
